import React from 'react';
import { AssignmentConfiguration } from '../../../../types/workflow';

interface AssignmentConfigProps {
  configuration: AssignmentConfiguration;
  onChange: (config: AssignmentConfiguration) => void;
  isReadOnly: boolean;
}

const AssignmentConfig: React.FC<AssignmentConfigProps> = ({
  configuration,
  onChange,
  isReadOnly,
}) => {
  const updateConfig = (field: keyof AssignmentConfiguration, value: any) => {
    onChange({
      ...configuration,
      [field]: value,
    });
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Assign To
        </label>
        <select
          value={configuration.assignTo || 'group'}
          onChange={(e) => updateConfig('assignTo', e.target.value)}
          disabled={isReadOnly}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm disabled:bg-gray-100"
        >
          <option value="user">Specific User</option>
          <option value="group">Assignment Group</option>
          <option value="previousApprover">Previous Approver</option>
        </select>
      </div>

      {configuration.assignTo === 'user' && (
        <div>
          <label className="block text-sm font-medium text-gray-700">
            User ID
          </label>
          <input
            type="text"
            value={configuration.assigneeId || ''}
            onChange={(e) => updateConfig('assigneeId', e.target.value)}
            disabled={isReadOnly}
            placeholder="Enter user ID or email"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm disabled:bg-gray-100"
          />
        </div>
      )}

      {configuration.assignTo === 'group' && (
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Assignment Group
          </label>
          <input
            type="text"
            value={configuration.assignmentGroup || ''}
            onChange={(e) => updateConfig('assignmentGroup', e.target.value)}
            disabled={isReadOnly}
            placeholder="Enter group name"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm disabled:bg-gray-100"
          />
        </div>
      )}
    </div>
  );
};

export default AssignmentConfig;